// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.story-page {
    max-width: 980px;
    margin: 0 auto;
    padding: 8px 12px 40px;
    color: #1f2937;
}

.story-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
}

.story-top h1 {
    margin: 0;
    font-size: 26px;
    font-weight: 700;
    color: #1d4f91;
}

.story-top p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #6b7280;
}

.story-cancel-top,
.story-preview-btn,
.story-send,
.story-save {
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

.story-cancel-top {
    border: 1px solid #cfd6df;
    background: #ffffff;
    color: #374151;
    border-radius: 6px;
    padding: 8px 16px;
}

.story-errors {
    background: #fdecec;
    border: 1px solid #f3c2c2;
    border-radius: 8px;
    padding: 14px 16px;
    margin-bottom: 14px;
}

.story-errors strong {
    display: block;
    font-size: 13px;
    color: #b02a37;
    margin-bottom: 6px;
}

.story-errors div {
    font-size: 12.5px;
    color: #8f2028;
    line-height: 1.6;
}

.story-block {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 18px 20px 20px;
    margin-bottom: 14px;
}

.story-block-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 14px;
}

.story-block h2 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #111827;
}

.story-req {
    color: #dc2626;
}

.story-seg-group {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.story-seg {
    border: 1px solid #d1d5db;
    background: #f3f4f6;
    color: #4b5563;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
}

.story-seg.on {
    background: #1d6fe8;
    border-color: #1d6fe8;
    color: #ffffff;
}

.story-grid {
    display: grid;
    grid-template-columns: 1.4fr 0.8fr;
    gap: 16px;
}

.story-grid.two {
    grid-template-columns: 1fr 1fr;
}

.story-label {
    display: block;
    font-size: 12.5px;
    color: #4b5563;
    margin-bottom: 6px;
}

.story-input,
.story-select,
.story-area {
    width: 100%;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
    color: #111827;
    outline: none;
}

.story-input,
.story-select {
    height: 40px;
    padding: 0 12px;
}

.story-area {
    min-height: 88px;
    padding: 10px 12px;
    line-height: 1.5;
    resize: vertical;
    font-family: inherit;
}

.story-input:focus,
.story-select:focus,
.story-area:focus {
    border-color: #1d6fe8;
}

.story-input.invalid,
.story-select.invalid,
.story-area.invalid,
.story-menu-btn.invalid {
    border-color: #dc2626;
    background: #fff8f8;
}

.story-input.invalid:focus,
.story-select.invalid:focus,
.story-area.invalid:focus,
.story-menu-btn.invalid:focus {
    border-color: #dc2626;
}

.story-editor.invalid {
    border-color: #dc2626;
}

.story-field-error {
    color: #b02a37;
    font-size: 12.5px;
    margin-top: 6px;
}

.story-q-row.invalid,
.story-stars.invalid,
.story-share-line.invalid,
.story-block-head.invalid {
    box-shadow: 0 0 0 1px #dc2626;
    border-radius: 6px;
}

.story-input:disabled,
.story-select:disabled {
    background: #f9fafb;
    color: #6b7280;
}

.story-hint,
.story-muted {
    font-size: 12px;
    color: #6b7280;
    margin-top: 6px;
}

.story-linked {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 12px;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 13px;
    color: #1d4f91;
}

.story-linked button {
    border: 0;
    background: transparent;
    color: #b02a37;
    text-decoration: underline;
    cursor: pointer;
    font-size: 12.5px;
}

.story-matches {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    margin-top: 12px;
    overflow: hidden;
}

.story-match {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border: 0;
    border-bottom: 1px solid #f3f4f6;
    background: #ffffff;
    text-align: left;
    cursor: pointer;
}

.story-match:hover {
    background: #f8fafc;
}

.story-match strong {
    display: block;
    font-size: 13.5px;
    color: #1d4f91;
}

.story-match em {
    display: block;
    margin-top: 2px;
    font-style: normal;
    font-size: 11.5px;
    color: #6b7280;
}

.story-match span {
    font-size: 12px;
    color: #1d6fe8;
    font-weight: 600;
}

.story-warn {
    background: #fff9e6;
    border: 1px solid #f0e0b0;
    border-radius: 6px;
    padding: 10px 12px;
    margin-top: 12px;
    font-size: 12.5px;
    color: #8a6d1f;
}

.story-menu {
    position: relative;
}

.story-menu-btn {
    width: 100%;
    min-height: 40px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    color: #111827;
    text-align: left;
}

.story-caret {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #6b7280;
    flex: 0 0 auto;
}

.story-popover {
    position: absolute;
    top: 46px;
    left: 0;
    right: 0;
    z-index: 40;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    box-shadow: 0 12px 30px rgba(17, 24, 39, 0.12);
    padding: 8px;
    max-height: 280px;
    overflow-y: auto;
}

.story-option {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
    border: 0;
    border-radius: 5px;
    background: transparent;
    cursor: pointer;
    font-size: 13px;
    color: #111827;
    text-align: left;
}

.story-option input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    width: 16px;
    height: 16px;
    margin: 0;
}

.story-option:hover {
    background: #f3f4f6;
}

.story-option.locked {
    color: #9ca3af;
    cursor: not-allowed;
}

.story-option.locked:hover,
.story-option:disabled:hover {
    background: transparent;
}

.story-check.locked,
.story-option:disabled .story-check {
    background: #f3f4f6;
    border-color: #d1d5db;
}

.story-check {
    width: 16px;
    height: 16px;
    border-radius: 3px;
    border: 1.5px solid #b9c2cb;
    flex: 0 0 auto;
}

.story-check.on {
    background: #1d6fe8;
    border-color: #1d6fe8;
    color: #ffffff;
    font-size: 11px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.story-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
}

.story-cat-chip {
    background: #1d6fe8;
    color: #ffffff;
    border-radius: 14px;
    padding: 4px 10px;
    font-size: 12px;
}

.story-nested {
    margin-top: 14px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 14px;
    background: #fafbfc;
}

.story-q-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: 16px;
}

.story-q {
    font-size: 13.5px;
    color: #111827;
}

.story-editor {
    position: relative;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    margin-top: 8px;
    background: #ffffff;
    overflow: hidden;
}

.story-narrative-image-hit {
    position: absolute;
    z-index: 2;
}

.story-narrative-image-remove {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 50%;
    background: #dc2626;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    opacity: 0;
}

.story-narrative-image-hit:hover .story-narrative-image-remove {
    opacity: 1;
}

.story-narrative-image-remove::after {
    content: "Remove";
    position: absolute;
    right: 34px;
    top: 50%;
    transform: translateY(-50%);
    background: #111827;
    color: #ffffff;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
}

.story-narrative-image-remove:hover::after {
    opacity: 1;
}

.story-editor .ql-toolbar.ql-snow {
    border: 0;
    border-bottom: 1px solid #e5e7eb;
}

.story-editor .ql-container.ql-snow {
    border: 0;
    min-height: 160px;
    font-size: 13.5px;
}

.story-editor .ql-editor img {
    max-width: 100%;
    height: auto !important;
}

.story-detail-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
}

.story-detail-title {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #1d4f91;
}

.story-detail-edit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 1px solid #d6e4f5;
    border-radius: 8px;
    background: #ffffff;
    color: #1d4f91;
    text-decoration: none;
}

.story-detail-edit:hover {
    background: #e8f1ff;
    color: #1d4f91;
}

.story-detail-edit .icon-edit {
    font-size: 16px;
    line-height: 1;
}

.story-detail-card {
    background: #ffffff;
    border: 1px solid #e6edf5;
    border-radius: 12px;
    padding: 22px 24px 26px;
}

.story-detail-top {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px 16px;
}

.story-detail-top .story-stars {
    margin-top: 0;
}

.story-detail-kicker {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #6b7280;
}

.story-detail-narrator {
    margin-top: 2px;
    font-size: 18px;
    font-weight: 600;
    color: #0b3454;
}

.story-detail-stars {
    margin-top: 0;
    margin-left: auto;
    flex-shrink: 0;
}

.story-detail-headline {
    margin: 0;
    flex: 1 1;
    min-width: 0;
    padding: 12px 14px;
    background: #f4f7fb;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.45;
    color: #1d4f91;
}

.story-detail-section {
    margin-top: 18px;
}

.story-detail-empty {
    margin-top: 6px;
    color: #6b7280;
}

.story-detail-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

.story-detail-tags span {
    background: #f3f4f6;
    color: #374151;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 12.5px;
    font-weight: 600;
}

.story-detail-tags.markers span {
    background: #ffffff;
    border: 1px solid #d6e4f5;
    color: #1d4f91;
}

.story-detail-narrative {
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px solid #eef2f6;
    font-size: 15px;
    line-height: 1.6;
    color: #1f2937;
}

.story-detail-narrative p:last-child {
    margin-bottom: 0;
}

.story-detail-narrative img {
    max-width: 100%;
    height: auto !important;
    display: block;
}

.story-attachments {
    list-style: none;
    margin: 10px 0 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.story-attachments a {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    width: 148px;
    color: #1d4f91;
    text-decoration: none;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.35;
    word-break: break-word;
}

.story-attachment-image {
    display: block;
    width: 148px;
    height: 110px;
    object-fit: contain;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #d6e4f5;
    padding: 8px;
}

.story-count {
    text-align: right;
    font-size: 12px;
    color: #6b7280;
    margin-top: 6px;
}

.story-count.warn {
    color: #b02a37;
}

.story-stars {
    display: flex;
    gap: 8px;
    margin-top: 8px;
}

.story-star {
    border: 1px solid #e5e7eb;
    background: #ffffff;
    color: #d1d5db;
    border-radius: 6px;
    padding: 6px 8px;
    cursor: pointer;
    font-size: 14px;
}

.story-star.on {
    color: #f5b400;
    border-color: #f5d76e;
    background: #fffbeb;
}

.story-star.static {
    cursor: default;
}

.story-share-line {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13.5px;
    color: #111827;
    margin-top: 8px;
}

.story-person {
    border: 1px solid #d1d5db;
    background: #ffffff;
    color: #374151;
    border-radius: 16px;
    padding: 6px 12px;
    font-size: 12.5px;
    cursor: pointer;
}

.story-person.on {
    background: #1d6fe8;
    border-color: #1d6fe8;
    color: #ffffff;
}

.story-two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
}

.story-tabs {
    display: flex;
    gap: 8px;
    margin-top: 14px;
}

.story-tab {
    border: 1px solid #d1d5db;
    background: #ffffff;
    color: #4b5563;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 13px;
    cursor: pointer;
}

.story-tab.on {
    background: #1d6fe8;
    border-color: #1d6fe8;
    color: #ffffff;
    font-weight: 600;
}

.story-sub {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    color: #6b7280;
    text-transform: uppercase;
    margin: 14px 0 8px;
}

.story-add,
.story-added,
.story-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 16px;
    padding: 5px 10px;
    font-size: 12px;
}

.story-add {
    background: #ffffff;
    border: 1px solid #d1d5db;
    color: #374151;
}

.story-add.suggest {
    border-color: #93c5fd;
    color: #1d4f91;
    background: #eff6ff;
}

.story-add button,
.story-info,
.story-chip button {
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    font-size: 12px;
    padding: 0;
}

.story-info {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid currentColor;
    font-size: 10px;
    font-weight: 700;
}

.story-added,
.story-chip {
    background: #1d6fe8;
    border: 1px solid #1d6fe8;
    color: #ffffff;
}

.story-help {
    margin-top: 8px;
    padding: 8px 10px;
    background: #f8fafc;
    border-left: 3px solid #1d6fe8;
    border-radius: 4px;
    font-size: 12.5px;
}

.story-search-wrap {
    position: relative;
    margin-top: 12px;
}

.story-search-wrap .story-input {
    padding-left: 32px;
}

.story-search-wrap i {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    font-style: normal;
}

.story-results {
    margin-top: 10px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 8px 10px;
    max-height: 240px;
    overflow-y: auto;
}

.story-result {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px solid #f3f4f6;
}

.story-pill {
    background: #ffffff;
    border: 1px solid #1d6fe8;
    color: #1d6fe8;
    border-radius: 14px;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
}

.story-onprofile {
    font-size: 11px;
    opacity: 0.85;
}

.story-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 4px;
}

.story-preview-btn {
    background: #ffffff;
    border: 1px solid #1d6fe8;
    color: #1d6fe8;
    border-radius: 6px;
    padding: 10px 16px;
}

.story-send {
    background: #ffffff;
    border: 1px solid #1d4f91;
    color: #1d4f91;
    border-radius: 6px;
    padding: 10px 16px;
}

.story-save {
    background: #1d6fe8;
    color: #ffffff;
    border: 0;
    border-radius: 6px;
    padding: 10px 18px;
}

.story-save:disabled,
.story-send:disabled,
.story-preview-btn:disabled,
.story-cancel-top:disabled {
    opacity: 0.6;
    cursor: default;
}

.story-modal {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.45);
    z-index: 100;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    overflow-y: auto;
    padding: 32px 20px;
}

.story-modal-card {
    background: #ffffff;
    border-radius: 10px;
    width: 100%;
    max-width: 720px;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
    overflow: hidden;
}

.story-modal-card.wide {
    max-width: 1200px;
}

.story-preview-pane .story-detail-headline {
    white-space: nowrap;
}

.story-modal-bar {
    padding: 12px 18px;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 700;
    color: #111827;
}

.story-modal-bar button {
    border: 0;
    background: transparent;
    font-size: 20px;
    cursor: pointer;
}

.story-page .form-label:empty {
    display: none;
}

@media (max-width: 720px) {
    .story-grid,
    .story-grid.two,
    .story-two-col,
    .story-block-head,
    .story-q-row,
    .story-top {
        display: block;
    }

    .story-seg-group,
    .story-cancel-top {
        margin-top: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/story/StoryForm.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;;;;IAII,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;;;IAII,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;;;IAII,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,8CAA8C;IAC9C,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;;IAGI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;IAGI,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;;IAII,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;;;;;;QAMI,cAAc;IAClB;;IAEA;;QAEI,eAAe;IACnB;AACJ","sourcesContent":[".story-page {\n    max-width: 980px;\n    margin: 0 auto;\n    padding: 8px 12px 40px;\n    color: #1f2937;\n}\n\n.story-top {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.story-top h1 {\n    margin: 0;\n    font-size: 26px;\n    font-weight: 700;\n    color: #1d4f91;\n}\n\n.story-top p {\n    margin: 4px 0 0;\n    font-size: 13px;\n    color: #6b7280;\n}\n\n.story-cancel-top,\n.story-preview-btn,\n.story-send,\n.story-save {\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.story-cancel-top {\n    border: 1px solid #cfd6df;\n    background: #ffffff;\n    color: #374151;\n    border-radius: 6px;\n    padding: 8px 16px;\n}\n\n.story-errors {\n    background: #fdecec;\n    border: 1px solid #f3c2c2;\n    border-radius: 8px;\n    padding: 14px 16px;\n    margin-bottom: 14px;\n}\n\n.story-errors strong {\n    display: block;\n    font-size: 13px;\n    color: #b02a37;\n    margin-bottom: 6px;\n}\n\n.story-errors div {\n    font-size: 12.5px;\n    color: #8f2028;\n    line-height: 1.6;\n}\n\n.story-block {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 18px 20px 20px;\n    margin-bottom: 14px;\n}\n\n.story-block-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 14px;\n}\n\n.story-block h2 {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 700;\n    color: #111827;\n}\n\n.story-req {\n    color: #dc2626;\n}\n\n.story-seg-group {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.story-seg {\n    border: 1px solid #d1d5db;\n    background: #f3f4f6;\n    color: #4b5563;\n    border-radius: 6px;\n    padding: 6px 12px;\n    font-size: 12.5px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.story-seg.on {\n    background: #1d6fe8;\n    border-color: #1d6fe8;\n    color: #ffffff;\n}\n\n.story-grid {\n    display: grid;\n    grid-template-columns: 1.4fr 0.8fr;\n    gap: 16px;\n}\n\n.story-grid.two {\n    grid-template-columns: 1fr 1fr;\n}\n\n.story-label {\n    display: block;\n    font-size: 12.5px;\n    color: #4b5563;\n    margin-bottom: 6px;\n}\n\n.story-input,\n.story-select,\n.story-area {\n    width: 100%;\n    box-sizing: border-box;\n    background: #ffffff;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-size: 14px;\n    color: #111827;\n    outline: none;\n}\n\n.story-input,\n.story-select {\n    height: 40px;\n    padding: 0 12px;\n}\n\n.story-area {\n    min-height: 88px;\n    padding: 10px 12px;\n    line-height: 1.5;\n    resize: vertical;\n    font-family: inherit;\n}\n\n.story-input:focus,\n.story-select:focus,\n.story-area:focus {\n    border-color: #1d6fe8;\n}\n\n.story-input.invalid,\n.story-select.invalid,\n.story-area.invalid,\n.story-menu-btn.invalid {\n    border-color: #dc2626;\n    background: #fff8f8;\n}\n\n.story-input.invalid:focus,\n.story-select.invalid:focus,\n.story-area.invalid:focus,\n.story-menu-btn.invalid:focus {\n    border-color: #dc2626;\n}\n\n.story-editor.invalid {\n    border-color: #dc2626;\n}\n\n.story-field-error {\n    color: #b02a37;\n    font-size: 12.5px;\n    margin-top: 6px;\n}\n\n.story-q-row.invalid,\n.story-stars.invalid,\n.story-share-line.invalid,\n.story-block-head.invalid {\n    box-shadow: 0 0 0 1px #dc2626;\n    border-radius: 6px;\n}\n\n.story-input:disabled,\n.story-select:disabled {\n    background: #f9fafb;\n    color: #6b7280;\n}\n\n.story-hint,\n.story-muted {\n    font-size: 12px;\n    color: #6b7280;\n    margin-top: 6px;\n}\n\n.story-linked {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-top: 12px;\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    border-radius: 6px;\n    padding: 10px 12px;\n    font-size: 13px;\n    color: #1d4f91;\n}\n\n.story-linked button {\n    border: 0;\n    background: transparent;\n    color: #b02a37;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: 12.5px;\n}\n\n.story-matches {\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    margin-top: 12px;\n    overflow: hidden;\n}\n\n.story-match {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 10px 12px;\n    border: 0;\n    border-bottom: 1px solid #f3f4f6;\n    background: #ffffff;\n    text-align: left;\n    cursor: pointer;\n}\n\n.story-match:hover {\n    background: #f8fafc;\n}\n\n.story-match strong {\n    display: block;\n    font-size: 13.5px;\n    color: #1d4f91;\n}\n\n.story-match em {\n    display: block;\n    margin-top: 2px;\n    font-style: normal;\n    font-size: 11.5px;\n    color: #6b7280;\n}\n\n.story-match span {\n    font-size: 12px;\n    color: #1d6fe8;\n    font-weight: 600;\n}\n\n.story-warn {\n    background: #fff9e6;\n    border: 1px solid #f0e0b0;\n    border-radius: 6px;\n    padding: 10px 12px;\n    margin-top: 12px;\n    font-size: 12.5px;\n    color: #8a6d1f;\n}\n\n.story-menu {\n    position: relative;\n}\n\n.story-menu-btn {\n    width: 100%;\n    min-height: 40px;\n    box-sizing: border-box;\n    background: #ffffff;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 8px 12px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #111827;\n    text-align: left;\n}\n\n.story-caret {\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 6px solid #6b7280;\n    flex: 0 0 auto;\n}\n\n.story-popover {\n    position: absolute;\n    top: 46px;\n    left: 0;\n    right: 0;\n    z-index: 40;\n    background: #ffffff;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    box-shadow: 0 12px 30px rgba(17, 24, 39, 0.12);\n    padding: 8px;\n    max-height: 280px;\n    overflow-y: auto;\n}\n\n.story-option {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px;\n    border: 0;\n    border-radius: 5px;\n    background: transparent;\n    cursor: pointer;\n    font-size: 13px;\n    color: #111827;\n    text-align: left;\n}\n\n.story-option input[type=\"checkbox\"] {\n    position: absolute;\n    opacity: 0;\n    width: 16px;\n    height: 16px;\n    margin: 0;\n}\n\n.story-option:hover {\n    background: #f3f4f6;\n}\n\n.story-option.locked {\n    color: #9ca3af;\n    cursor: not-allowed;\n}\n\n.story-option.locked:hover,\n.story-option:disabled:hover {\n    background: transparent;\n}\n\n.story-check.locked,\n.story-option:disabled .story-check {\n    background: #f3f4f6;\n    border-color: #d1d5db;\n}\n\n.story-check {\n    width: 16px;\n    height: 16px;\n    border-radius: 3px;\n    border: 1.5px solid #b9c2cb;\n    flex: 0 0 auto;\n}\n\n.story-check.on {\n    background: #1d6fe8;\n    border-color: #1d6fe8;\n    color: #ffffff;\n    font-size: 11px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.story-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 10px;\n}\n\n.story-cat-chip {\n    background: #1d6fe8;\n    color: #ffffff;\n    border-radius: 14px;\n    padding: 4px 10px;\n    font-size: 12px;\n}\n\n.story-nested {\n    margin-top: 14px;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 14px;\n    background: #fafbfc;\n}\n\n.story-q-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-top: 16px;\n}\n\n.story-q {\n    font-size: 13.5px;\n    color: #111827;\n}\n\n.story-editor {\n    position: relative;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    margin-top: 8px;\n    background: #ffffff;\n    overflow: hidden;\n}\n\n.story-narrative-image-hit {\n    position: absolute;\n    z-index: 2;\n}\n\n.story-narrative-image-remove {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 28px;\n    height: 28px;\n    border: 0;\n    border-radius: 50%;\n    background: #dc2626;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    opacity: 0;\n}\n\n.story-narrative-image-hit:hover .story-narrative-image-remove {\n    opacity: 1;\n}\n\n.story-narrative-image-remove::after {\n    content: \"Remove\";\n    position: absolute;\n    right: 34px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: #111827;\n    color: #ffffff;\n    border-radius: 4px;\n    padding: 4px 8px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.2;\n    white-space: nowrap;\n    opacity: 0;\n    pointer-events: none;\n}\n\n.story-narrative-image-remove:hover::after {\n    opacity: 1;\n}\n\n.story-editor .ql-toolbar.ql-snow {\n    border: 0;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.story-editor .ql-container.ql-snow {\n    border: 0;\n    min-height: 160px;\n    font-size: 13.5px;\n}\n\n.story-editor .ql-editor img {\n    max-width: 100%;\n    height: auto !important;\n}\n\n.story-detail-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.story-detail-title {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #1d4f91;\n}\n\n.story-detail-edit {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border: 1px solid #d6e4f5;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #1d4f91;\n    text-decoration: none;\n}\n\n.story-detail-edit:hover {\n    background: #e8f1ff;\n    color: #1d4f91;\n}\n\n.story-detail-edit .icon-edit {\n    font-size: 16px;\n    line-height: 1;\n}\n\n.story-detail-card {\n    background: #ffffff;\n    border: 1px solid #e6edf5;\n    border-radius: 12px;\n    padding: 22px 24px 26px;\n}\n\n.story-detail-top {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px 16px;\n}\n\n.story-detail-top .story-stars {\n    margin-top: 0;\n}\n\n.story-detail-kicker {\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    color: #6b7280;\n}\n\n.story-detail-narrator {\n    margin-top: 2px;\n    font-size: 18px;\n    font-weight: 600;\n    color: #0b3454;\n}\n\n.story-detail-stars {\n    margin-top: 0;\n    margin-left: auto;\n    flex-shrink: 0;\n}\n\n.story-detail-headline {\n    margin: 0;\n    flex: 1;\n    min-width: 0;\n    padding: 12px 14px;\n    background: #f4f7fb;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.45;\n    color: #1d4f91;\n}\n\n.story-detail-section {\n    margin-top: 18px;\n}\n\n.story-detail-empty {\n    margin-top: 6px;\n    color: #6b7280;\n}\n\n.story-detail-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 8px;\n}\n\n.story-detail-tags span {\n    background: #f3f4f6;\n    color: #374151;\n    border-radius: 6px;\n    padding: 4px 8px;\n    font-size: 12.5px;\n    font-weight: 600;\n}\n\n.story-detail-tags.markers span {\n    background: #ffffff;\n    border: 1px solid #d6e4f5;\n    color: #1d4f91;\n}\n\n.story-detail-narrative {\n    margin-top: 18px;\n    padding-top: 16px;\n    border-top: 1px solid #eef2f6;\n    font-size: 15px;\n    line-height: 1.6;\n    color: #1f2937;\n}\n\n.story-detail-narrative p:last-child {\n    margin-bottom: 0;\n}\n\n.story-detail-narrative img {\n    max-width: 100%;\n    height: auto !important;\n    display: block;\n}\n\n.story-attachments {\n    list-style: none;\n    margin: 10px 0 0;\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.story-attachments a {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n    width: 148px;\n    color: #1d4f91;\n    text-decoration: none;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.35;\n    word-break: break-word;\n}\n\n.story-attachment-image {\n    display: block;\n    width: 148px;\n    height: 110px;\n    object-fit: contain;\n    background: #f8fafc;\n    border-radius: 8px;\n    border: 1px solid #d6e4f5;\n    padding: 8px;\n}\n\n.story-count {\n    text-align: right;\n    font-size: 12px;\n    color: #6b7280;\n    margin-top: 6px;\n}\n\n.story-count.warn {\n    color: #b02a37;\n}\n\n.story-stars {\n    display: flex;\n    gap: 8px;\n    margin-top: 8px;\n}\n\n.story-star {\n    border: 1px solid #e5e7eb;\n    background: #ffffff;\n    color: #d1d5db;\n    border-radius: 6px;\n    padding: 6px 8px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.story-star.on {\n    color: #f5b400;\n    border-color: #f5d76e;\n    background: #fffbeb;\n}\n\n.story-star.static {\n    cursor: default;\n}\n\n.story-share-line {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13.5px;\n    color: #111827;\n    margin-top: 8px;\n}\n\n.story-person {\n    border: 1px solid #d1d5db;\n    background: #ffffff;\n    color: #374151;\n    border-radius: 16px;\n    padding: 6px 12px;\n    font-size: 12.5px;\n    cursor: pointer;\n}\n\n.story-person.on {\n    background: #1d6fe8;\n    border-color: #1d6fe8;\n    color: #ffffff;\n}\n\n.story-two-col {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n}\n\n.story-tabs {\n    display: flex;\n    gap: 8px;\n    margin-top: 14px;\n}\n\n.story-tab {\n    border: 1px solid #d1d5db;\n    background: #ffffff;\n    color: #4b5563;\n    border-radius: 6px;\n    padding: 6px 12px;\n    font-size: 13px;\n    cursor: pointer;\n}\n\n.story-tab.on {\n    background: #1d6fe8;\n    border-color: #1d6fe8;\n    color: #ffffff;\n    font-weight: 600;\n}\n\n.story-sub {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.4px;\n    color: #6b7280;\n    text-transform: uppercase;\n    margin: 14px 0 8px;\n}\n\n.story-add,\n.story-added,\n.story-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    border-radius: 16px;\n    padding: 5px 10px;\n    font-size: 12px;\n}\n\n.story-add {\n    background: #ffffff;\n    border: 1px solid #d1d5db;\n    color: #374151;\n}\n\n.story-add.suggest {\n    border-color: #93c5fd;\n    color: #1d4f91;\n    background: #eff6ff;\n}\n\n.story-add button,\n.story-info,\n.story-chip button {\n    border: 0;\n    background: transparent;\n    color: inherit;\n    cursor: pointer;\n    font-size: 12px;\n    padding: 0;\n}\n\n.story-info {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    border: 1px solid currentColor;\n    font-size: 10px;\n    font-weight: 700;\n}\n\n.story-added,\n.story-chip {\n    background: #1d6fe8;\n    border: 1px solid #1d6fe8;\n    color: #ffffff;\n}\n\n.story-help {\n    margin-top: 8px;\n    padding: 8px 10px;\n    background: #f8fafc;\n    border-left: 3px solid #1d6fe8;\n    border-radius: 4px;\n    font-size: 12.5px;\n}\n\n.story-search-wrap {\n    position: relative;\n    margin-top: 12px;\n}\n\n.story-search-wrap .story-input {\n    padding-left: 32px;\n}\n\n.story-search-wrap i {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #9ca3af;\n    font-style: normal;\n}\n\n.story-results {\n    margin-top: 10px;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    padding: 8px 10px;\n    max-height: 240px;\n    overflow-y: auto;\n}\n\n.story-result {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 8px 0;\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.story-pill {\n    background: #ffffff;\n    border: 1px solid #1d6fe8;\n    color: #1d6fe8;\n    border-radius: 14px;\n    padding: 4px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.story-onprofile {\n    font-size: 11px;\n    opacity: 0.85;\n}\n\n.story-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 4px;\n}\n\n.story-preview-btn {\n    background: #ffffff;\n    border: 1px solid #1d6fe8;\n    color: #1d6fe8;\n    border-radius: 6px;\n    padding: 10px 16px;\n}\n\n.story-send {\n    background: #ffffff;\n    border: 1px solid #1d4f91;\n    color: #1d4f91;\n    border-radius: 6px;\n    padding: 10px 16px;\n}\n\n.story-save {\n    background: #1d6fe8;\n    color: #ffffff;\n    border: 0;\n    border-radius: 6px;\n    padding: 10px 18px;\n}\n\n.story-save:disabled,\n.story-send:disabled,\n.story-preview-btn:disabled,\n.story-cancel-top:disabled {\n    opacity: 0.6;\n    cursor: default;\n}\n\n.story-modal {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.45);\n    z-index: 100;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    overflow-y: auto;\n    padding: 32px 20px;\n}\n\n.story-modal-card {\n    background: #ffffff;\n    border-radius: 10px;\n    width: 100%;\n    max-width: 720px;\n    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n    overflow: hidden;\n}\n\n.story-modal-card.wide {\n    max-width: 1200px;\n}\n\n.story-preview-pane .story-detail-headline {\n    white-space: nowrap;\n}\n\n.story-modal-bar {\n    padding: 12px 18px;\n    border-bottom: 1px solid #e5e7eb;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-weight: 700;\n    color: #111827;\n}\n\n.story-modal-bar button {\n    border: 0;\n    background: transparent;\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.story-page .form-label:empty {\n    display: none;\n}\n\n@media (max-width: 720px) {\n    .story-grid,\n    .story-grid.two,\n    .story-two-col,\n    .story-block-head,\n    .story-q-row,\n    .story-top {\n        display: block;\n    }\n\n    .story-seg-group,\n    .story-cancel-top {\n        margin-top: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
